import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionFlowSessionStore} from '../state/question-flow-session.store';
import { forEach } from 'lodash';

declare const $: any;
declare const easyAutocomplete: any;

@Component({
    selector: 'app-question-vehicle-make-year-model',
    templateUrl: './question-vehicle-make-year-model.component.html',
    styleUrls: ['./question-vehicle-make-year-model.component.scss'],
    standalone: false
})
export class QuestionVehicleMakeYearModelComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() showLabel = false;
  @Input() readOnly = false;
  @Input() isEdit = false;
  @Input() evi = false;
  @Input() showToolTip = false;
  @Input() toolTipContent = '';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Output() questionAnswer = new EventEmitter<any>();

  vehicle_makes = [];
  vehicle_models = [];
  vehicle_years = [];
  make = '';
  year = '';
  model = '';
  uniqueMakeControlId = `${newGuid()}-make`;
  uniqueModelControlId = `${newGuid()}-model`;
  uniqueYearControlId = `${newGuid()}-year`;
  makesLoading = false;
  yearsLoading = false;
  modelsLoading = false;

  constructor(private questionService: GlobalQuestionService, private questionFlowSessionStore: QuestionFlowSessionStore) {
  }

  ngOnInit(): void {
    console.info();
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answer) {
        const answer = JSON.parse(this.question?.answer);
        if (answer) {
          this.make = answer?.make;
          this.year = answer?.year;
          this.model = answer?.model;
          this.getVehicleMakes();
        } else {
          this.getVehicleMakes();
        }
      } else {
        this.getVehicleMakes();
      }
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.isEdit?.currentValue !== changes?.isEdit?.previousValue) {
      this.isEdit = changes?.isEdit?.currentValue;
    }
  }

  getVehicleMakes(): void {
    if (!this.makesLoading && !this.readOnly) {
      this.makesLoading = true;
      //this.questionService.spinner(true);
      this.questionService.spinnerTransparent(true);
      this.questionService.getVehicleMakes()
        .subscribe(x => {
          if (!x?.length) {
            //this.questionService.spinner(false);
            this.questionService.spinnerTransparent(false);
            this.makesLoading = false;
            return;
          }
          this.vehicle_makes = [];
          this.vehicle_years = [];
          this.vehicle_models = [];
          this.vehicle_makes = x;
          this.initMakeAutoComplete();
          this.makesLoading = false;
          if (this.make) {
            //this.questionService.spinner(false);
            this.questionService.spinnerTransparent(false);
            this.getVehicleYears();
          } else {
            //this.questionService.spinner(false);
            this.questionService.spinnerTransparent(false);
          }
          if (!this.question?.isEdit && !this.make) {
            setTimeout(() => {
              $(`#${this.uniqueMakeControlId}`).focus();
            }, 50);
          }
        });
    }
  }

  getVehicleYears(): void {
    if (this.make && !this.yearsLoading) {
      this.yearsLoading = true;
      this.questionService.getVehicleYears(this.make)
        .subscribe(x => {
          if (!x?.length) {
            this.yearsLoading = false;
            return;
          }
          this.vehicle_models = [];
          this.vehicle_years = [];
          this.vehicle_years = x;
          this.initYearAutoComplete();
          this.yearsLoading = false;
          if (this.make && this.year) {
            this.getVehicleModels();
          } else {
          }
          if (!this.question?.isEdit && this.make && !this.year) {
            setTimeout(() => {
              $(`#${this.uniqueYearControlId}`).focus();
            }, 50);
          }
        });
    }
  }

  getVehicleModels(): void {
    if (this.make && this.year && !this.modelsLoading) {
      this.modelsLoading = true;
      this.questionService.getVehicleModels(this.year.toString(), this.make)
        .subscribe(x => {
          if (!x?.length) {
            this.modelsLoading = false;
            return;
          }
          this.vehicle_models = [];
          this.vehicle_models = x;
          this.initModelAutoComplete();
          this.modelsLoading = false;
          if (!this.question?.isEdit && this.make && this.year && !this.model) {
            setTimeout(() => {
              $(`#${this.uniqueModelControlId}`).focus();
            }, 50);
          }
        });
    }
  }

  submitChanges(): void {
    console.log(this.evi)
    if (this.make && this.year && this.model) {
      const answer = {
        make: this.make,
        year: this.year,
        model: this.model
      };
      this.question.answer = JSON.stringify(answer);
      this.questionAnswer.emit(this.question);
      if (this.evi) {
        this.questionFlowSessionStore.update({
          item_id: this.question?.item_id,
          class_id: this.question?.product_class_id ?? this.question?.class_id,
          flow_id: this.question?.flow_id
        });
        this.questionService.saveAnswerOnly(this.question).subscribe(() => {
          this.runCallProcIfEvi();
        });
      }
    } else {
      this.question.answer = '';
      this.questionAnswer.emit(this.question);
    }
  }

  runCallProcIfEvi(): void {
    console.log(this.evi, this.question)
    if (this.evi && this.question?.call_proc) {
      this.questionService.runProcOnly(this.question);
    }
  }

  initMakeAutoComplete(): void {
    $(`#${this.uniqueMakeControlId}`).easyAutocomplete({
      data: this.vehicle_makes,
      getValue: x => {
        return x.make;
      },
      list: {
        match: {
          enabled: true
        },
        maxNumberOfElements: 100,
        sort: {
          enabled: true // alphabetical order
        },
        onChooseEvent: () => {
          const selected = $(`#${this.uniqueMakeControlId}`).getSelectedItemData();
          this.make = selected?.make;
          this.model = '';
          this.year = '';
          this.getVehicleYears();
          this.submitChanges();
        },
        onHideListEvent: () => {
          if (!this.make) {
            this.make = '';
            this.year = '';
            this.model = '';
          }
          if (!this.vehicle_makes.some(x => x.make.toLowerCase() === this.make.toLowerCase())) {
            this.make = '';
            this.year = '';
            this.model = '';
          }
          if (this.make && !this.yearsLoading) {
            this.getVehicleYears();
          }
          this.submitChanges();
        }
      }
    });
  }

  initYearAutoComplete(): void {
    $(`#${this.uniqueYearControlId}`).easyAutocomplete({
      data: this.vehicle_years,
      getValue: x => {
        return x.regyear;
      },
      list: {
        match: {
          enabled: true
        },
        maxNumberOfElements: 100,
        sort: {
          enabled: true // alphabetical order
        },
        onChooseEvent: () => {
          const selected = $(`#${this.uniqueYearControlId}`).getSelectedItemData();
          this.year = selected?.regyear;
          this.model = '';
          this.getVehicleModels();
          this.submitChanges();
        },
        onHideListEvent: () => {
          if (!this.year) {
            this.year = '';
            this.model = '';
          }
          if (!this.vehicle_years.some(x => x.regyear.toString() === this.year.toString())) {
            this.year = '';
            this.model = '';
          }

          if (this.make && this.year && !this.modelsLoading) {
            this.getVehicleModels();
          }
          this.submitChanges();
        }
      }
    });
  }

  initModelAutoComplete(): void {
    $(`#${this.uniqueModelControlId}`).easyAutocomplete({
      data: this.vehicle_models,
      getValue: x => {
        return x.variant;
      },
      list: {
        match: {
          enabled: true
        },
        maxNumberOfElements: 100,
        sort: {
          enabled: true // alphabetical order
        },
        onChooseEvent: () => {
          const selected = $(`#${this.uniqueModelControlId}`).getSelectedItemData();
          this.model = selected?.variant;
          this.submitChanges();
        },
        onHideListEvent: () => {
          if (!this.model) {
            this.model = '';
          }
          if (!this.vehicle_models.some(x => x.variant.toLowerCase() === this.model.toLowerCase())) {
            this.model = '';
          }
          this.submitChanges();
        }
      }
    });
  }

}
